export const selectCurrentUser = (state) => state.user.user;
export const selectUserState= (state) => state.user.state;
export const selectCurrentUserProjects = (state) => state.user.projects;
